import { useTranslation } from 'react-i18next';

interface Props {
  /** Override the default `app.loading` text. */
  text?: string;
}

/** Muted `Loading…` placeholder used while a query is in flight. */
export function LoadingPlaceholder({ text }: Props) {
  const { t } = useTranslation();
  return <p className="text-slate-500">{text ?? t('app.loading')}</p>;
}
